import axios from "axios";
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();

/**
 * Get list of roles' permissions.
 * 
 * @returns {Promise<Object>}
 */
export function list() {
    return axios.get(`${apiUrl}/permissions`);
}

